module.exports = __webpack_public_path__ + "img/logo.f1e94551.png";